/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
					url 		=> router path
					name 		=> name to display in sidebar
					slug 		=> router path name
					icon 		=> Feather Icon component/icon name
					tag 		=> text to display on badge
					tagColor 	=> class to apply on badge element
					i18n 		=> Internationalization
					submenu 	=> submenu of current item (current item will become dropdown )
								NOTE: Submenu don't have any icon(you can add icon if u want to display)
					isDisabled 	=> disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Version: 1.1
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
	{
		url: "/admin/dashboard",
		name: "AdminDashboard",
		slug: "dashboard",
		icon: "HomeIcon",
		i18n: "Dashboard",

	},
	// {
	// 	header: "Apps",
	// 	i18n: "Apps",
	// },
	{
		url: null,
		name: "Master",
		slug: "master",
		icon: "SettingsIcon",
		i18n: "Masters",
		submenu: [
			// {
			// 	url: '/admin/category',
			// 	name: "Category",
			// 	slug: "category",
			// 	i18n: "Category",
			// },
			{
				url: '/admin/interest',
				name: "Interest",
				slug: "interest",
				i18n: "Interests",
			},
			{
				url: '/admin/faq',
				name: "FAQ",
				slug: "faqs",
				i18n: "FAQ",
			},
			{
				url: '/admin/setting',
				name: "Setting",
				slug: "setting",
				i18n: "Settings",
			},
		]
	},
	{
		url: null,
		name: "Leads",
		slug: "leads",
		icon: "SlackIcon",
		i18n: "Leads",
		submenu: [
			{
				url: '/admin/leads/student',
				name: "Students",
				slug: "students",
				i18n: "Students",
			},
			{
				url: '/admin/leads/teacher',
				name: "Teachers",
				slug: "teachers",
				i18n: "Teachers",
			},
			{
				url: '/admin/leads/investor',
				name: "Investors",
				slug: "investors",
				i18n: "Investors",
			},
		]
	},
	{
		url: null,
		name: "Users",
		slug: "user",
		icon: "UserIcon",
		i18n: "Users",
		submenu: [
			// {
			// 	url: '/users/admins',
			// 	name: "Admins",
			// 	slug: "admin",
			// 	i18n: "Admins",
			// },
			{
				url: '/admin/students',
				name: "Students",
				slug: "students",
				i18n: "Students",
			},
			{
				url: '/admin/teachers',
				name: "Teachers",
				slug: "teachers",
				i18n: "Teachers",
			},
			{
				url: '/admin/teacher-kyc',
				name: "Teacher-kyc",
				slug: "teacher-kyc",
				i18n: "Teacher's KYC",
			},
			{
				url: '/admin/reported-users',
				name: "ReportedUsers",
				slug: "reported-users",
				i18n: "Reported Users",
			},
			{
				url: '/admin/deleted-users',
				name: "Deleted Users",
				slug: "deleted-users",
				i18n: "Deleted Users",
			},
			{
				url: '/admin/thrivecart-subscribed-users',
				name: "Thrivecart Subscribed Users",
				slug: "thrivecart-subscribed-users",
				i18n: "Thrivecart Subscribed Users",
			},
		]
	},
	{
		url: "/apps/classes",
		name: "Classes",
		slug: "classes",
		icon: "FeatherIcon",
		i18n: "Classes",
		submenu: [
			{
				url: '/admin/online-classes',
				name: "Online Classes",
				slug: "online-classes",
				i18n: "Online Classes",
			},
			{
				url: '/admin/offline-classes',
				name: "Offline Classes",
				slug: "offline-classes",
				i18n: "Offline Classes",
			},
			{
				url: '/admin/requested-classes',
				name: "Requested Classes",
				slug: "requested-classes",
				i18n: "Requested Classes",
			},
		]
	},
	{
		url: "/apps/classes",
		name: "Events",
		slug: "events",
		icon: "GridIcon",
		i18n: "Events",
		submenu: [
			{
				url: '/admin/online-events',
				name: "Online Events",
				slug: "online-event",
				i18n: "Online Events",
			},
			{
				url: '/admin/offline-events',
				name: "Offline Events",
				slug: "offline-events",
				i18n: "Offline Events",
			},
		]
	},
	// {
	// 	url: "/admin/subscription-management",
	// 	name: "Subscriptions",
	// 	slug: "subscription-management",
	// 	icon: "SlackIcon",
	// 	i18n: "Subscriptions",
	// },
	{
		url: "/admin/transactions",
		name: "Transactions",
		slug: "transactions",
		icon: "DollarSignIcon",
		i18n: "Transactions",
	},
	{
		url: "/admin/bookings",
		name: "Bookings",
		slug: "bookings",
		icon: "CalendarIcon",
		i18n: "Bookings",
	},
	// {
	// 	url: "/admin/payout",
	// 	name: "Payout",
	// 	slug: "payout",
	// 	icon: "DollarSignIcon",
	// 	i18n: "Payout",
	// },
	{
		url: "/admin/reported-listings",
		name: "Reported Listings",
		slug: "reported-listings",
		icon: "FileTextIcon",
		i18n: "Reported Listings",
	},
	// {
	// 	url: "/admin/notifications",
	// 	name: "Notifications",
	// 	icon: "BellIcon",
	// 	tagColor: "danger",
	// 	i18n: "Notifications",
	// },
	{
		url: '/admin/error-logs',
		name: "Error Logs",
		icon: "ListIcon",
		slug: "error-logs",
		i18n: "Error Logs",
	},
	// {
	// 	url: '/forms/form-wizard',
	// 	name: "Form Wizard",
	// 	icon: "PackageIcon",
	// 	tag: 'New',
	// 	tagColor: 'danger',
	// 	slug: "extraComponentFormWizard",
	// 	i18n: "FormWizard",
	// },
	{
		url: '/admin/device-information-tracking',
		name: "Device Information Tracking",
		icon: "SmartphoneIcon",
		slug: "device-information-tracking",
		i18n: "Device Tracking",
	},
	// {
	// 	header: "Pages",
	// 	i18n: "Pages",
	// },
	// {
	// 	url: null,
	// 	name: "Authentication",
	// 	icon: "PieChartIcon",
	// 	i18n: "Authentication",
	// 	submenu: [
	// 		{
	// 			url: '/pages/login',
	// 			name: "Login",
	// 			slug: "pagesLogin",
	// 			i18n: "Login",
	// 			target: '_blank',
	// 		},
	// 		{
	// 			url: '/pages/register',
	// 			name: "Register",
	// 			slug: "pagesRegister",
	// 			i18n: "Register",
	// 			target: '_blank',
	// 		},
	// 		{
	// 			url: '/pages/forgot-password',
	// 			name: "Forgot Password",
	// 			slug: "pagesForgotPassword",
	// 			i18n: "ForgotPassword",
	// 			target: '_blank',
	// 		},
	// 		{
	// 			url: '/pages/reset-password',
	// 			name: "Reset Password",
	// 			slug: "pagesResetPassword",
	// 			i18n: "ResetPassword",
	// 			target: '_blank',
	// 		},
	// 		{
	// 			url: '/pages/lock-screen',
	// 			name: "Lock Screen",
	// 			slug: "pagesLockScreen",
	// 			i18n: "LockScreen",
	// 			target: '_blank',
	// 		},
	// 	]
	// },
	// {
	// 	url: '/pages/comingsoon',
	// 	name: "Coming Soon",
	// 	icon: "ClockIcon",
	// 	i18n: "ComingSoon",
	// 	target: '_blank',
	// },
	// {
	// 	url: null,
	// 	name: "Error",
	// 	icon: "AlertOctagonIcon",
	// 	i18n: "Error",
	// 	submenu: [
	// 		{
	// 			url: '/pages/error-404',
	// 			name: "404",
	// 			slug: "pageError404",
	// 			i18n: "404",
	// 			target: '_blank',
	// 		},
	// 		{
	// 			url: '/pages/error-500',
	// 			name: "500",
	// 			slug: "pageError500",
	// 			i18n: "500",
	// 			target: '_blank',
	// 		}
	// 	]
	// },
	// {
	// 	url: '/pages/maintenance',
	// 	name: "Maintenance",
	// 	slug: "pageMaintenance",
	// 	icon: "AnchorIcon",
	// 	i18n: "Maintenance",
	// 	target: '_blank',
	// },
	// {
	// 	url: '/pages/profile',
	// 	name: "Profile",
	// 	icon: "UserIcon",
	// 	i18n: "Profile",

	// },
	// {
	// 	url: '/pages/faq',
	// 	name: "FAQ",
	// 	icon: "HelpCircleIcon",
	// 	i18n: "FAQ",

	// },
	// {
	// 	url: '/pages/knowledge-base',
	// 	name: "Knowledge Base",
	// 	icon: "InfoIcon",
	// 	i18n: "KnowledgeBase",

	// },
	// {
	// 	url: '/pages/search',
	// 	name: "Search",
	// 	icon: "SearchIcon",
	// 	i18n: "Search",

	// },
	// {
	// 	url: '/pages/invoice',
	// 	name: "Invoice",
	// 	icon: "InfoIcon",
	// 	i18n: "Invoice",

	// },
	// {
	// 	header: "Charts & Maps",
	// 	i18n: "ChartsAndMaps",
	// },
	// {
	// 	url: null,
	// 	name: "Charts",
	// 	icon: "PieChartIcon",
	// 	tag: '3',
	// 	tagColor: 'success',
	// 	i18n: "Charts",
	// 	submenu: [
	// 		{
	// 			url: '/charts-and-maps/charts/apex-charts',
	// 			name: "Apex Charts",
	// 			slug: "extraComponentChartsApexCharts",
	// 			i18n: "ApexCharts",
	// 		},
	// 		{
	// 			url: '/charts-and-maps/charts/chartjs',
	// 			name: "chartjs",
	// 			slug: "extraComponentChartsChartjs",
	// 			i18n: "chartjs",
	// 		},
	// 		{
	// 			url: '/charts-and-maps/charts/echarts',
	// 			name: "echarts",
	// 			slug: "extraComponentChartsEcharts",
	// 			i18n: "echarts",
	// 		},
	// 	]
	// },
	// {
	// 	url: '/charts-and-maps/maps/google-map',
	// 	name: "Google Map",
	// 	icon: "MapIcon",
	// 	slug: "extraComponentMapsGoogleMap",
	// 	i18n: "GoogleMap",
	// },
	// {
	// 	header: "Extensions",
	// 	i18n: "Extensions",
	// },
	// {
	// 	url: '/extensions/select',
	// 	name: "Select",
	// 	icon: "PocketIcon",
	// 	slug: "extraComponentSelect",
	// 	i18n: "Select",
	// },
	// {
	// 	url: '/extensions/quill-editor',
	// 	name: "Quill Editor",
	// 	icon: "EditIcon",
	// 	slug: "extraComponentQuillEditor",
	// 	i18n: "QuillEditor",
	// },
	// {
	// 	url: '/extensions/drag-and-drop',
	// 	name: "Drag & Drop",
	// 	icon: "DropletIcon",
	// 	slug: "extraComponentDragAndDrop",
	// 	i18n: "DragAndDrop",
	// },
	// {
	// 	url: '/extensions/datepicker',
	// 	name: "Datepicker",
	// 	icon: "CalendarIcon",
	// 	slug: "extraComponentDatepicker",
	// 	i18n: "Datepicker",
	// },
	// {
	// 	header: "Others",
	// 	i18n: "Others",
	// },
	// {
	// 	url: null,
	// 	name: "Menu Levels",
	// 	icon: "MenuIcon",
	// 	i18n: "MenuLevels",
	// 	submenu: [
	// 		{
	// 			url: null,
	// 			name: "Menu Level 2.1",
	// 			i18n: "MenuLevel2p1",
	// 		},
	// 		{
	// 			url: null,
	// 			name: "Menu Level 2.2",
	// 			i18n: "MenuLevel2p2",
	// 			submenu: [
	// 				{
	// 					url: null,
	// 					name: "Menu Level 3.1",
	// 					i18n: "MenuLevel3p1",
	// 				},
	// 				{
	// 					url: null,
	// 					name: "Menu Level 3.2",
	// 					i18n: "MenuLevel3p2",
	// 				},
	// 			]
	// 		},
	// 	]
	// },
	// {
	// 	url: null,
	// 	name: "Disabled Menu",
	// 	icon: "EyeOffIcon",
	// 	i18n: "DisabledMenu",
	// 	isDisabled: true,
	// },

	// {
	// 	header: "Support",
	// 	i18n: "Support",
	// },
	// {
	// 	url: 'https://pixinvent.com/demo/vuesax-vuejs-admin-dashboard-template/documentation/',
	// 	name: "Documentation",
	// 	icon: "BookOpenIcon",
	// 	slug: "external",
	// 	i18n: "Documentation",
	// 	target: "_blank"
	// },
	// {
	// 	url: 'https://pixinvent.ticksy.com/',
	// 	name: "Raise Support",
	// 	icon: "LifeBuoyIcon",
	// 	slug: "external",
	// 	i18n: "RaiseSupport",
	// 	target: "_blank"
	// },
]